<template>
  <button
    type="button"
    :class="['zg-close-button', {
      [`zg-close-button--size-${size}`]: size
    }]"
  >
    <span class="visually-hidden">
      Click to close
    </span>

    <zg-icon
      icon="close"
      :size="size"
    />
  </button>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon.vue'

  export default {
    name: 'ZgCloseButton',
    components: {
      ZgIcon
    },
    props: {
      size: {
        type: String,
        required: false,
        default: 'small',
        validator: value => [
          'xsmall',
          'small'
        ].includes(value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-close-button {
    display: inline-flex;
    cursor: pointer;
    outline: 0;
    border: none;
    background: transparent;
    margin: 0;
    border-radius: 100%;
    transition: all 0.3s ease;

    ::v-deep svg.zg-icon {
      right: 0;
    }

    &:hover {
      ::v-deep svg.zg-icon {
        color: color(brand-500);
      }
    }

    &:focus {
      box-shadow: 0 0 0 4px color(brand-100);
    }

    &:focus:not(:focus-visible) {
      box-shadow: none;
    }
  }

  // ? ----------------------------------------------------------------------
  // size
  // ? ----------------------------------------------------------------------

  .zg-close-button--size-xsmall {
    padding: rem(1px);
  }

  .zg-close-button--size-small {
    padding: rhythm(xsmall);
  }
</style>
